module.exports = __webpack_public_path__ + "img/sv28.1515f07b.svg";